import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "portal-footer" }
const _hoisted_2 = { class: "portal-footer__main" }
const _hoisted_3 = { class: "home-shell portal-footer__main-inner" }
const _hoisted_4 = { class: "portal-footer__brand-col" }
const _hoisted_5 = { class: "portal-footer__contact" }
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "portal-footer__bottom" }
const _hoisted_8 = { class: "home-shell portal-footer__bottom-inner" }
const _hoisted_9 = { class: "portal-footer__biz" }
const _hoisted_10 = ["href"]
const _hoisted_11 = ["href"]
const _hoisted_12 = ["href"]
const _hoisted_13 = { class: "portal-footer__bottom-row" }
const _hoisted_14 = { class: "portal-footer__copy" }
const _hoisted_15 = {
  class: "portal-footer__legal",
  "aria-label": "약관"
}
const _hoisted_16 = ["href"]

import { BIZ_INFO_URL, COMPANY, PORTAL_LEGAL_LINKS } from '@/constants/legalContent'


export default /*@__PURE__*/_defineComponent({
  __name: 'PortalFooter',
  setup(__props) {

const year = new Date().getFullYear()

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            to: "/",
            class: "portal-footer__brand"
          }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createElementVNode("img", {
                src: "/favicon.svg",
                width: "32",
                height: "32",
                alt: "",
                "aria-hidden": "true"
              }, null, -1),
              _createTextVNode(" 장기요양지원센터 ", -1)
            ]))]),
            _: 1
          }),
          _cache[4] || (_cache[4] = _createElementVNode("p", { class: "portal-footer__org" }, " 장기요양기관의 급여·회계·운영 업무를 지원합니다. 운영: (주)함우리 · 카이온 ", -1)),
          _createElementVNode("div", _hoisted_5, [
            _cache[1] || (_cache[1] = _createElementVNode("span", null, "상담 운영", -1)),
            _cache[2] || (_cache[2] = _createElementVNode("strong", null, "평일 09:30 – 17:30", -1)),
            _createElementVNode("a", {
              href: `mailto:${_unref(COMPANY).email}`
            }, _toDisplayString(_unref(COMPANY).email), 9, _hoisted_6)
          ]),
          _createVNode(_component_router_link, {
            to: "/mall",
            target: "_blank",
            rel: "noopener noreferrer",
            class: "portal-footer__mall-link"
          }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createTextVNode(" 함우리몰 바로가기 ", -1)
            ]))]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("p", _hoisted_9, [
          _createTextVNode(_toDisplayString(_unref(COMPANY).legalName) + " · 대표 " + _toDisplayString(_unref(COMPANY).owner) + " · 사업자등록번호 ", 1),
          _createElementVNode("a", {
            href: _unref(BIZ_INFO_URL),
            target: "_blank",
            rel: "noopener noreferrer"
          }, _toDisplayString(_unref(COMPANY).bizNumber), 9, _hoisted_10),
          _createTextVNode(" · " + _toDisplayString(_unref(COMPANY).address) + " · 대표번호 ", 1),
          _createElementVNode("a", {
            href: `tel:${_unref(COMPANY).phone.replace(/-/g, '')}`
          }, _toDisplayString(_unref(COMPANY).phone), 9, _hoisted_11),
          _cache[5] || (_cache[5] = _createTextVNode(" · ", -1)),
          _createElementVNode("a", {
            href: `mailto:${_unref(COMPANY).email}`
          }, _toDisplayString(_unref(COMPANY).email), 9, _hoisted_12)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("p", _hoisted_14, "© " + _toDisplayString(_unref(year)) + " " + _toDisplayString(_unref(COMPANY).name) + ". All rights reserved.", 1),
          _createElementVNode("nav", _hoisted_15, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(PORTAL_LEGAL_LINKS), (item) => {
              return (_openBlock(), _createBlock(_component_router_link, {
                key: item.to,
                to: item.to,
                class: _normalizeClass({ 'portal-footer__legal-strong': item.strong })
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.label), 1)
                ]),
                _: 2
              }, 1032, ["to", "class"]))
            }), 128)),
            _createElementVNode("a", {
              href: _unref(BIZ_INFO_URL),
              target: "_blank",
              rel: "noopener noreferrer"
            }, "사업자정보확인", 8, _hoisted_16)
          ])
        ])
      ])
    ])
  ]))
}
}

})